import { HostListener, OnDestroy } from '@angular/core';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
import { PaginatorState } from '../../models/paginator.model';
import { BaseService } from '../../services/base.service';
@Component({
  selector: 'app-list-base',
  templateUrl: './list-base.component.html',
})
export class ListBaseComponent<T> implements OnDestroy {
  private subscriptions: Subscription[] = [];
  isLoading: boolean;
  paginator: PaginatorState;
  searchValue: string;

  readonly EMPTY_Model: T = {} as T;
  constructor(
    public translateService: TranslateService,
    public baseService: BaseService<T>,
  ) {

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
  createImgPath = (serverPath?: string) => {
    if (serverPath)
      return `${environment.patchUrl}/${serverPath}`;
  }
  convertExamTypeToText(examType: number): string {
    const questionType = [
      { name: 'مستويات', value: 1 },
      { name: 'فئات', value: 2 },
    ];
    const matchingType = questionType.find(type => type.value === examType);
    return matchingType ? matchingType.name : "Unknown";
  }
  getAll() {
    this.baseService.fetch();
    this.paginator = this.baseService.paginator;
    const sb = this.baseService.isLoading$.subscribe(res => this.isLoading = res);
    this.subscriptions.push(sb);
  }

  getAllById(id: string) {
    this.baseService.fetchById(id);
    this.paginator = this.baseService.paginator;
    const sb = this.baseService.isLoading$.subscribe(res => this.isLoading = res);
    this.subscriptions.push(sb);
  }
  searchCriteria: any;
  // search($event: any) {
  //   this.searchValue = $event.target.value;
  //   this.baseService.paginator.page == 1;
  //   this.baseService.fetchWithNameSearch(this.searchValue);
  // }

  paginate(paginator: PaginatorState) {
    this.baseService.patchState({ paginator });
  }


  showActivityCode(text: string): string {
    return text.slice(0, 40);
  }
  showAllText: boolean = false;
  showAll(text: string) {
    this.showAllText = true;
    Swal.fire({
      title: text,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    })
  }
  delete(id: string) {
    Swal.fire({
      title: this.translateService.instant('MENU.AreYouSure'),
      text: this.translateService.instant('MENU.YouWillNotAble'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translateService.instant('MENU.YesDelete'),
      cancelButtonText: this.translateService.instant('MENU.NoKeep')
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          this.translateService.instant('MENU.Deleted'),
          this.translateService.instant('MENU.YourFileDeleted'),
          'success'
        )
        const sb = this.baseService.delete$(id).pipe(
          tap(),
          finalize(() => {
            this.baseService.fetch();
            () => { }
          })
        ).subscribe();
        this.subscriptions.push(sb);

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.translateService.instant('MENU.Cancelled'),
          this.translateService.instant('MENU.YourImaginarySafe'),
          'error'
        )
      }
    })
  }


  checkAccess(value: String): boolean {
    return true
  }

  menuVisibleMap: { [key: string]: boolean } = {};

  toggleMenu(event: Event, referenceId: string) {
    event.preventDefault();
    this.menuVisibleMap[referenceId] = !this.menuVisibleMap[referenceId];
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const targetElement = event.target as HTMLElement;
    if (!targetElement.closest('.menu, .btn')) {
      this.menuVisibleMap = {};
    }
  }
}
